require("./ProgressNav.marko.scss");
"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Activity/components/ProgressNav.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("3fa121"),
    marko_node0 = marko_createElement("div", {
        "class": "classroom-progress"
      }, "0", null, 2, 0, {
        i: marko_const_nextId()
      })
      .e("ul", {
          "class": "list-unstyled"
        }, null, null, 2)
        .e("li", {
            "class": "nav-item border-bottom cursor-pointer px-3"
          }, null, null, 2)
          .e("div", {
              "class": "blue-grey-text font-medium-2 py-2"
            }, null, null, 1)
            .t("Introduction")
          .e("div", {
              "class": "collapse show pb-1"
            }, null, null, 1)
            .e("ul", {
                "class": "widget-timeline"
              }, null, null, 4)
              .e("li", {
                  "class": "timeline-items timeline-icon-success check active"
                }, null, null, 3)
                .e("div", {
                    "class": "timeline-time"
                  }, null, null, 1)
                  .t("92% Completed")
                .e("h6", {
                    "class": "timeline-title"
                  }, null, null, 1)
                  .t("Python history")
                .e("p", {
                    "class": "timeline-text text-muted"
                  }, null, null, 1)
                  .t("2 hours ago")
              .e("li", {
                  "class": "timeline-items timeline-icon-warning ongoing active"
                }, null, null, 3)
                .e("div", {
                    "class": "timeline-time"
                  }, null, null, 1)
                  .t("Ongoing")
                .e("h6", {
                    "class": "timeline-title"
                  }, null, null, 1)
                  .t("Install Environment")
                .e("p", {
                    "class": "timeline-text text-muted"
                  }, null, null, 1)
                  .t("15 minutes")
              .e("li", {
                  "class": "timeline-items timeline-icon-secondary active"
                }, null, null, 2)
                .e("h6", {
                    "class": "timeline-title"
                  }, null, null, 1)
                  .t("Types, Variables & Interfaces")
                .e("p", {
                    "class": "timeline-text text-muted"
                  }, null, null, 1)
                  .t("15 minutes")
              .e("li", {
                  "class": "timeline-items timeline-icon-secondary active"
                }, null, null, 2)
                .e("h6", {
                    "class": "timeline-title"
                  }, null, null, 1)
                  .t("Conditional Statements")
                .e("p", {
                    "class": "timeline-text text-muted"
                  }, null, null, 1)
                  .t("15 minutes")
        .e("li", {
            "class": "nav-item border-bottom cursor-pointer px-3"
          }, null, null, 2)
          .e("div", {
              "class": "blue-grey-text font-medium-2 py-2"
            }, null, null, 1)
            .t("Procedure of how to setup a full featured IDE")
          .e("div", {
              "class": "collapse show pb-1"
            }, null, null, 1)
            .e("ul", {
                "class": "widget-timeline"
              }, null, null, 2)
              .e("li", {
                  "class": "timeline-items timeline-icon-secondary"
                }, null, null, 1)
                .e("h6", {
                    "class": "timeline-title"
                  }, null, null, 1)
                  .t("Programming Typos")
              .e("li", {
                  "class": "timeline-items timeline-icon-secondary"
                }, null, null, 2)
                .e("div", {
                    "class": "timeline-time"
                  }, null, null, 0)
                .e("h6", {
                    "class": "timeline-title"
                  }, null, null, 1)
                  .t("Declaration of Variables")
      .t(" ");

function render(input, out, __component, component, state) {
  var data = input;

  out.n(marko_node0, component);
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
